/* eslint-disable react-hooks/exhaustive-deps */
import { withRouter } from "../_shared/withRouter";
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";
import Header from "../template/_common/header";
import SidebarComponent from "../template/admin/sidebarComponent";
import SidebarArrow from "../template/_common/sidebarArrow";
import ConfirmationModal from "../template/_common/confirmModal";
import PaginationOwn from "../template/_common/ownPagination";
import { globalAlert, globalLoader } from "../actions/commonActions";
import { logOut } from "../_shared/commonFunction";
import { StatusBadge } from "./lmsOverview";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  lmsListCoursesApi,
  lmsUpdateCourseStatusApi,
} from "./_lmsActions";

const STATUS_TABS = [
  { key: "all", label: "All", icon: "fas fa-layer-group" },
  { key: "draft", label: "Draft", icon: "fas fa-pencil-ruler" },
  { key: "published", label: "Published", icon: "fas fa-rocket" },
  { key: "archived", label: "Archived", icon: "fas fa-archive" },
];

const LmsCourses = (props) => {
  const { t } = useTranslation();

  const [navbarToggle, setNavbarToggle] = useState(false);
  const [allowView, setAllowView] = useState(false);
  const [dataList, setDataList] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [pageSize, setPageSize] = useState(25);
  const [currentPage, setCurrentPage] = useState(1);
  const [statusCounts, setStatusCounts] = useState({ all: 0, draft: 0, published: 0, archived: 0 });
  const [totalCount, setTotalCount] = useState(0);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [confirmTarget, setConfirmTarget] = useState(null);
  const visibleTabs = STATUS_TABS.filter((item) => !item.more);



  const statusFromSearch = (search = "") => {
    const status = new URLSearchParams(search).get("status") || "all";
    return STATUS_TABS.some((item) => item.key === status) ? status : "all";
  };
  const [statusFilter, setStatusFilter] = useState(() =>
    statusFromSearch(props?.location?.search)
  );
  useEffect(() => {
    callBasicApi();
  }, [currentPage, pageSize, statusFilter]);
  useEffect(() => {
    const nextStatus = statusFromSearch(props?.location?.search);
    if (nextStatus !== statusFilter) {
      setStatusFilter(nextStatus);
      setCurrentPage(1);
    }
  }, [props?.location?.search]);
  useEffect(() => {
    const params = new URLSearchParams(props?.location?.search || "");
    if (!params.has("status")) {
      props?.history?.replace({
        pathname: "/admin/lms/courses",
        search: `?status=${statusFilter}`,
      });
    }
  }, []);



  const callBasicApi = async ({ page = currentPage, limit = pageSize, status = statusFilter, search = searchValue } = {}) => {
    try {
      globalLoader(true);
      let query = `?page=${page}&limit=${limit}`;
      if (status !== "all") query += `&status=${status}`;
      if (search) query += `&search=${encodeURIComponent(search)}`;
      const res = await lmsListCoursesApi(query);
      if (res?.data?.status === 200) {
        const data = res?.data?.data || {};

        const courses = data?.list || data?.courses || [];

        setDataList(courses);
        setTotalCount(
          data?.pagination?.total ??
          data?.totalCount ??
          data?.total ??
          courses.length
        );
        setStatusCounts({
          all: Number(data?.counts?.all ?? courses.length) || 0,
          draft: Number(data?.counts?.draft ?? courses.filter((c) => c.status === "draft").length) || 0,
          published: Number(data?.counts?.published ?? courses.filter((c) => c.status === "published").length) || 0,
          archived: Number(data?.counts?.archived ?? courses.filter((c) => c.status === "archived").length) || 0,
        });
        setAllowView(true);
      } else {
        globalAlert("error", res?.data?.message);
      }
      globalLoader(false);
    } catch (error) {
      globalAlert("error", error?.response?.data?.message);
      if (error?.response?.data?.status === 401) {
        logOut(props?.history, "/admin/login");
      }
      globalLoader(false);
    }
  };


  const searchFilter = (ev) => {
    ev.preventDefault();
    setCurrentPage(1);
    callBasicApi({ page: 1 });
  };

  const goToPageFunc = (val, data) => {
    if (data === "prev" && currentPage > 1) setCurrentPage(currentPage - 1);
    else if (data === "next" && currentPage < Math.ceil(totalCount / pageSize))
      setCurrentPage(currentPage + 1);
    else if (val?.target?.value) setCurrentPage(Number(val.target.value));
  };

  const askArchive = (course) => {
    setConfirmTarget(course);
    setConfirmOpen(true);
  };

  const confirmArchive = async (val) => {
    if (val && confirmTarget) {
      try {
        globalLoader(true);

        const res = await lmsUpdateCourseStatusApi(
          confirmTarget?._id || confirmTarget?.courseId,
          "archived"
        );

        if (res?.data?.status === 200) {
          globalAlert("success", res?.data?.message);
          callBasicApi();
        } else {
          globalAlert("error", res?.data?.message);
          globalLoader(false);
        }
      } catch (error) {
        globalAlert("error", error?.response?.data?.message);
        globalLoader(false);
      }
    }

    setConfirmOpen(false);
    setConfirmTarget(null);
  };

  const selectStatus = (status) => {
    setStatusFilter(status);
    setCurrentPage(1);
    props?.history?.replace({
      pathname: "/admin/lms/courses",
      search: `?status=${status}`,
    });
  };

  return (
    <>
      <Helmet>
        <title>{t("admin.pageTitle.lmsCourses")} - eC-Card</title>
        <meta name="viewport" content="width=1200, initial-scale=1" />
      </Helmet>
      {allowView && (
        <div className="admin-portal">
          <Header roleType="admin" />
          <div className={`${navbarToggle ? "active" : ""} wrapper`}>
            <SidebarComponent
              navbarToggle={navbarToggle}
              roleType="admin"
              menu="lms"
              subMenu="lms-courses"
            />
            <div className="main">
              <div className="main-wrapper lms-courses-page">
                <div>
                  <p className="admin-banner">{t("admin.lms.courses.title")}</p>
                </div>
                <SidebarArrow handleSidebarToggle={setNavbarToggle} />

                <div className="custom-search-wrapper px-3 pt-3">
                  <div className="lms-toolbar">
                    <div className="lms-toolbar-left">
                      <form onSubmit={searchFilter} className="admin-search">
                        <div className="lms-search-bar">
                          <i className="fas fa-search lms-search-icon"></i>
                          <input
                            type="text"
                            className="form-control lms-search-input"
                            placeholder={t("admin.lms.courses.searchPlaceholder")}
                            value={searchValue}
                            onChange={(e) => setSearchValue(e.target.value)}
                          />
                        </div>
                        <button type="submit" className="btn secondary-btn lms-search-btn">
                          {t("common.go")}
                        </button>
                      </form>
                    </div>
                    <button
                      onClick={() => props?.history?.push("/admin/lms/course/new")}
                      className="btn secondary-btn modal-btn lms-toolbar-btn"
                    >
                      <i className="fas fa-plus"></i>{" "}
                      {t("admin.lms.courses.addButton")}
                    </button>
                  </div>
                </div>
                <div className="lms-course-status-tabs mt-3 mx-3" aria-label="course status">
                  {visibleTabs.map((item) => (
                    <button key={item.key} type="button" className={statusFilter === item.key ? "active" : ""} onClick={() => selectStatus(item.key)}>
                      <i className={item.icon}></i>
                      <span>{item.label}</span>
                      <strong>{statusCounts[item.key] ?? 0}</strong>
                    </button>
                  ))}
                </div>



                {dataList?.length > 0 ? (
                  <div className="table-wrapper px-3 pt-3">
                    <div className="lms-courses-table-card table-own table-responsive">
                      <table className="table table-hover lms-learner-table">
                        <thead className="table-head">
                          <tr>
                            <th>Course</th>
                            <th>Learners</th>
                            <th>{t("common.status")}</th>
                            <th>Created</th>
                            <th>{t("common.actions")}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {dataList.map((c, i) => (
                            <tr key={c?._id || c?.courseId || i}>
                              <td>
                                <CourseIdentity course={c} />
                              </td>
                              <td>
                                <LearnerStats course={c} />
                              </td>
                              <td>
                                <StatusBadge status={c?.status} t={t} />
                              </td>
                              <td>{formatDate(c?.createdAt)}</td>
                              <td>
                                <div className="lms-actions">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip id={`view-course-tooltip-${c?._id || i}`}>View course</Tooltip>}
                                  >
                                    <button
                                      className="btn btn-sm btn-info lms-course-action-btn"
                                      onClick={() =>
                                        props?.history?.push(
                                          `/admin/lms/course/detail/${c?.slug || c?._id || c?.courseId}`
                                        )
                                      }
                                    >
                                      <i className="fas fa-eye text-white"></i>
                                    </button>
                                  </OverlayTrigger>
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip id={`edit-course-tooltip-${c?._id || i}`}>Edit course</Tooltip>}
                                  >
                                    <button
                                      className="btn btn-sm secondary-sm-btn lms-course-action-btn"
                                      onClick={() =>
                                        props?.history?.push(
                                          `/admin/lms/course/${c?.slug || c?._id || c?.courseId}`
                                        )
                                      }
                                    >
                                      <i className="fas fa-pen"></i>
                                    </button>
                                  </OverlayTrigger>
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip id={`archive-course-tooltip-${c?._id || i}`}>
                                        {c.status === "archived" ? "Course already archived" : "Archive course"}
                                      </Tooltip>
                                    }
                                  >
                                    <span>
                                      <button
                                        className="btn btn-sm btn-danger lms-course-action-btn"
                                        onClick={() => askArchive(c)}
                                        disabled={c.status === "archived"}
                                      >
                                        <i className="fas fa-archive"></i>
                                      </button>
                                    </span>
                                  </OverlayTrigger>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                ) : (

                  <div className="px-3 pt-4 pb-4">
                    <div className="d-flex flex-column align-items-center justify-content-center p-5 bg-light rounded shadow-sm border">

                      <i className="far fa-folder-open fa-3x text-muted mb-3"></i>

                      <h5 className="text-secondary font-weight-bold">
                        Oops! No Courses Found
                      </h5>
                      <p className="text-muted mb-0 font-14">
                        {t("You have no course added please add a course.")}
                      </p>
                    </div>
                  </div>
                )}
                {dataList?.length > 0 && (
                  <div className="container-fluid pt-3">
                    <div className="lms-learner-pagination">
                      <PaginationOwn
                        pageSize={pageSize}
                        changePageSize={(v) => {
                          setPageSize(v.target.value);
                          setCurrentPage(1);
                        }}
                        goToPage={goToPageFunc}
                        totalCount={totalCount}
                        currentPage={currentPage}
                        applicationType={
                          dataList?.length > 1 ? "courses" : "course"
                        }
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
      {confirmOpen && (
        <ConfirmationModal
          open={confirmOpen}
          deleteInfo={[`${t("admin.lms.fields.courseTitle")} : ${confirmTarget?.title}`]}
          description={t("admin.lms.courses.confirmArchive")}
          onCloseModal={confirmArchive}
        />
      )}
    </>
  );
};

const CourseIdentity = ({ course }) => {
  const title = course?.title || "Untitled course";
  return (
    <div className="lms-course-list-identity">
      <div className="lms-course-list-thumb">
        {course?.thumbnailUrl ? (
          <img src={course.thumbnailUrl} alt="" />
        ) : (
          <span>{title.charAt(0).toUpperCase()}</span>
        )}
      </div>
      <div>
        <strong>{title}</strong>
      </div>
    </div>
  );
};

const LearnerStats = ({ course }) => {
  const enrolments = course?.enrolmentCount || 0;
  return (
    <div className="lms-course-learner-stats">
      <strong>{enrolments}</strong>
    </div>
  );
};

export const formatDate = (d) => {
  if (!d) return "-";
  try {
    return new Date(d).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  } catch {
    return "-";
  }
};

export default withRouter(LmsCourses);
